import { render, staticRenderFns } from "./cooDashboard.vue?vue&type=template&id=2bcfc3df&scoped=true"
import script from "./cooDashboard.vue?vue&type=script&lang=js"
export * from "./cooDashboard.vue?vue&type=script&lang=js"
import style0 from "./cooDashboard.vue?vue&type=style&index=0&id=2bcfc3df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcfc3df",
  null
  
)

export default component.exports